module.exports = __webpack_public_path__ + "img/Weapon_258.9da72bae.png";